import { createAction } from '@reduxjs/toolkit';

export const ACCEPT_CALL_ACTION_TYPE = 'saga/acceptCall';
export const acceptCallAction = createAction(ACCEPT_CALL_ACTION_TYPE);
